import UIButton from 'UIComponents/button/UIButton';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import H2 from 'UIComponents/elements/headings/H2';
import H3 from 'UIComponents/elements/headings/H3';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIToggle from 'UIComponents/input/UIToggle';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import styled from 'academy-common-lib/utils/Styling';
import { useGateOverride, useScopeOverride } from '../../accounts';
import { useDevtools, useRhumbDebug } from '../devtoolsQueries';

// @ts-expect-error adding stuff to the window
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
window.Academy = {};
const gateHelpText = {
  'AcademyCertification:ForcePartnerCertification': "This will enable you to see the UI but the the backend still won't return any Partner content"
};
const GateToggleContainer = styled(UIFlex).withConfig({
  displayName: "Devtools__GateToggleContainer",
  componentId: "sc-4cdewm-0"
})(["row-gap:16px;"]);
const GateToggle = ({
  gateName
}) => {
  const [override, setOverride, resetOverride] = useGateOverride(gateName);
  return /*#__PURE__*/_jsxs(GateToggleContainer, {
    direction: "column",
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      help: gateHelpText[gateName],
      label: gateName,
      children: /*#__PURE__*/_jsx(UIToggle, {
        checked: override || false,
        id: `mySavedItems-${gateName}`,
        onChange: ({
          target: {
            checked
          }
        }) => {
          setOverride(checked);
        }
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      onClick: resetOverride,
      children: "Reset"
    })]
  });
};
const scopeHelpText = {
  'academy-playlist-global-assignment': "This will enable you to see the UI but the the backend still won't accept any assignments unless you are a member of 53 with the correct scope"
};
const ScopeToggle = ({
  scopeName
}) => {
  const [override, setOverride, resetOverride] = useScopeOverride(scopeName);
  return /*#__PURE__*/_jsxs(GateToggleContainer, {
    direction: "column",
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      help: scopeHelpText[scopeName],
      label: scopeName,
      children: /*#__PURE__*/_jsx(UIToggle, {
        checked: override || false,
        id: `mySavedItems-${scopeName}`,
        onChange: ({
          target: {
            checked
          }
        }) => {
          setOverride(checked);
        }
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      onClick: resetOverride,
      children: "Reset"
    })]
  });
};
const RhumbDebuggingToggle = () => {
  const {
    value,
    setDebug
  } = useRhumbDebug();
  return /*#__PURE__*/_jsx(UIFormControl, {
    help: /*#__PURE__*/_jsxs("span", {
      children: ["Enable", ' ', /*#__PURE__*/_jsx("a", {
        href: "https://product.hubteam.com/docs/frontend/docs/react-rhumb.html#debugging",
        children: "debugging support"
      }), ' ', "for React Rhumb. Reload the page after toggling."]
    }),
    label: "React Rhumb Debug",
    children: /*#__PURE__*/_jsx(UIToggle, {
      checked: value || false,
      id: "rhumb-debug-toggle",
      onChange: ({
        target: {
          checked
        }
      }) => {
        setDebug(checked);
      }
    })
  });
};
export const Devtools = () => {
  const {
    isOpen,
    toggle
  } = useDevtools();
  return isOpen && /*#__PURE__*/_jsxs(UIPanel, {
    width: 450,
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: toggle
    }), /*#__PURE__*/_jsx(UIPanelHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: "Academy Devtools"
      })
    }), /*#__PURE__*/_jsxs(UIPanelBody, {
      children: [/*#__PURE__*/_jsxs(UIPanelSection, {
        children: [/*#__PURE__*/_jsx(H3, {
          children: "Override Gates"
        }), /*#__PURE__*/_jsx(GateToggle, {
          gateName: "Academy:SunsetCMS"
        }), /*#__PURE__*/_jsx(GateToggle, {
          gateName: "AcademyCertification:ForcePartnerCertification"
        })]
      }), /*#__PURE__*/_jsxs(UIPanelSection, {
        children: [/*#__PURE__*/_jsx(H3, {
          children: "Override Scopes"
        }), /*#__PURE__*/_jsx(ScopeToggle, {
          scopeName: "academy-playlist-global-assignment"
        })]
      }), /*#__PURE__*/_jsxs(UIPanelSection, {
        children: [/*#__PURE__*/_jsx(H3, {
          children: "Debug Toggles"
        }), /*#__PURE__*/_jsx(RhumbDebuggingToggle, {})]
      })]
    })]
  });
};